import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { Box, Container, Typography } from '@mui/material';
import { DataGrid, GridFooterContainer, GridPagination, GridToolbarColumnsButton, GridToolbarExportContainer, GridToolbarQuickFilter} from '@mui/x-data-grid';

import { Button } from '@mui/material'
import { callPostApi } from '../../components/API/ApiCallFunction';
import { useNavigate } from 'react-router-dom';

const ApiList = () => {

    const [allData,        setAllData]        = useState([]);
    const [loading,        setLoading]        = useState(false);
    const [pageIndex,      setPageIndex]      = useState(0);
    const [hasMoreData,    setHasMoreData]    = useState(true);
    const [filtersApplied, setFiltersApplied] = useState(false);
    const [filtersLoaded,  setFiltersLoaded]  = useState(false);
    
    const isInitialSessionLoad = useRef(false);
    const hasFetchedRef        = useRef(false);
    const navigate = useNavigate();

    const user = JSON.parse(sessionStorage.getItem("user") || "{}");
    const store_id = user.store_info.store_id;

    /* ------------------ DATE HELPER ------------------ */
    const getDateNDaysAgo = (n) => {
        const date = new Date();
        date.setDate(date.getDate() - n);
        const year = date.getFullYear();
        const month = (`0${date.getMonth() + 1}`).slice(-2);
        const day = (`0${date.getDate()}`).slice(-2);
        return `${year}-${month}-${day}`;
    };
      
    // Default Filter For Searching
    const defaultFilters = useMemo(() => ({store_id, start_date: getDateNDaysAgo(0), end_date: getDateNDaysAgo(0), fetchLimit: '10', pageSize: '10' }), [store_id]);
    const [filters, setFilters] = useState(defaultFilters);

    // Reset Data States
    const resetDataStates = () => 
    {
        setAllData([]);
        setPageIndex(0);
        setHasMoreData(true);
        setLoading(false);
    };

    // Apply Filters
    const applyFilters = () => 
    {
        setAllData([]);
        setPageIndex(0);
        setHasMoreData(true);
        setFiltersApplied(true);
    };

    // Clear Filters
    const clearFilters = () => 
    {
        setFilters(defaultFilters);
        setAllData([]);
        setPageIndex(0);
        setHasMoreData(true);
        sessionStorage.setItem('luckyDrawFilfer', JSON.stringify(defaultFilters));
        setFiltersApplied(true);
        fetchData();
    };

    // Load from sessionStorage
    useEffect(() => 
    {
        const storedState = sessionStorage.getItem('luckyDrawFilfer');
        if (storedState) 
        {
            try 
            {
                const parsedState = JSON.parse(storedState);
                setFilters({ ...defaultFilters, ...parsedState });
                isInitialSessionLoad.current = true;
                // setFiltersApplied(true);
            } 
            catch (error) 
            {
               
                sessionStorage.removeItem('luckyDrawFilfer');
            }
        }
    }, [defaultFilters]);

    // Fetch Data Function
    const fetchData = useCallback(async (page = pageIndex) => 
    {
        if (!filtersLoaded || loading || !hasMoreData) return;

        setLoading(true);
        try 
        {
            const StartNum = page * filters.fetchLimit;
            const payload = {mod: "CASHI_LUCKY_REDEEM_LIST", data_arr: {...filters,start: StartNum,limit: filters.fetchLimit,}};

            console.log(JSON.stringify(payload));

            const response = await callPostApi('store-cashi-report', payload);

            if (response.status === '200' && response.data) 
            {
                const apiResponse = response.data
                if (apiResponse.length > 0) 
                {
                    setAllData(prev => [...prev, ...apiResponse]);
                    setPageIndex(page);
                } 
                else {  setHasMoreData(false); }
                
                if (apiResponse.length < filters.fetchLimit) { setHasMoreData(false); }
            } 
            else 
            {
                setHasMoreData(false);
            }
        } 
        catch (error) { setHasMoreData(false); } 
        finally { setLoading(false); }

    }, [filters, filtersLoaded, loading, hasMoreData, pageIndex]);

    // Initial fetch trigger
    
     useEffect(() => { if (!filtersLoaded) setFiltersLoaded(true); }, [filtersLoaded]);

    // Save to sessionStorage
    useEffect(() => {
         if (!hasFetchedRef.current && filtersLoaded) {
            hasFetchedRef.current = true;
            fetchData();
        }
  
        if (filtersApplied) 
        {
            sessionStorage.setItem('luckyDrawFilfer', JSON.stringify(filters));
            if (!isInitialSessionLoad.current) { fetchData(0); }
            isInitialSessionLoad.current = false;
            setFiltersApplied(false);
        }
        const handleExternalRefresh = () => {
               resetDataStates();
               hasFetchedRef.current = false;
            //    setFiltersApplied(true);
               fetchData(0);
           };
           window.addEventListener('refreshPriceTable', handleExternalRefresh);
           return () => window.removeEventListener('refreshPriceTable', handleExternalRefresh);
    }, [filtersLoaded, filtersApplied, filters,fetchData]);
    
    const CustomToolbar = () => {
        return (
            <GridToolbarExportContainer sx={{ justifyContent: 'space-between', px: 2, py: 1 }}>
                <GridToolbarColumnsButton /><GridToolbarQuickFilter debounceMs={300} />
            </GridToolbarExportContainer>
        );
    };

    const CustomFooterWithLoadMore = ({ hasMoreData, loading, onLoadMore }) => (
      <GridFooterContainer sx={{ px: 2, py: 1, overflowX: 'hidden', }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', width: '100%', }} >
          
              {/* Left: Rows per page */}
              <Box sx={{ flex: 1 }} />
              {/* Center: Load More */}
              
              <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                  {hasMoreData ? (
                      <Button variant="contained" onClick={onLoadMore} disabled={loading} sx={{ minWidth: 120 }}>
                          {loading ? 'Loading...' : 'Load More'}
                      </Button>
                  ) : (<Typography variant="body2" color="text.secondary">No more records </Typography>)}
              </Box>

              {/* Right: Pagination - Increased width */}
              <Box sx={{ flex: 2, minWidth: 250, display: 'flex', justifyContent: 'flex-end' }}>
                  <GridPagination />
              </Box>
              
          </Box>
      </GridFooterContainer>
      );
    
    return (
    <div>        
    <Container>

        <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>

            <Button variant="contained" sx={{ background: "#1976d2" }}  onClick={() => navigate(-1)}> Back </Button>

            <Button sx={{background: "linear-gradient(195deg, #42424a, #191919)",color: "#ffffff", ml:'auto',
                boxShadow:"rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px", }}onClick={clearFilters}>Clear Filters</Button>
    
        </Box>

        <div className='mb-3'>
            <div className="row align-items-center g-2 searchFilter">
                               
                

                {/* Start Date */}
                <div className="col-12 col-md-2">
                    <input type="text" className="form-control" placeholder="Entry Start Date" value={filters.start_date}
                        onChange={(e) => setFilters(prev => ({ ...prev, start_date: e.target.value }))}
                        onFocus={e => e.target.type = 'date'} onBlur={e => e.target.type = 'text'} />
                </div>

                {/* End Date */}
                <div className="col-12 col-md-2">
                    <input type="text" className="form-control" placeholder="Entry End Date" value={filters.end_date}
                        onChange={(e) => setFilters(prev => ({ ...prev, end_date: e.target.value }))}
                        onFocus={e => e.target.type = 'date'} onBlur={e => e.target.type = 'text'} />
                </div>

                {/* Page Size Filter */}  
                <div className="col-12 col-md-2">
                    <select className="form-control" value={filters.fetchLimit} onChange={(e) => setFilters(prev => ({ ...prev, fetchLimit: e.target.value }))} >
                        <option value="">Record Fetch Limit</option>
                        {[{value: '10', label: '10'},{value:'20',label: '20' }].map(o => ( <option key={o.value} value={o.value}>{o.label}</option> ))}
                    </select>
                </div>    
              
                {/* Apply flter */}
                <div className="col-12 col-md-2 ms-auto">                                        
                    <Button  sx={{background:'linear-gradient(195deg, #49a3f1, #1A73E8)', color:'#ffffff',ml:1,
                        boxShadow: 'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px' }}
                          style={{float: 'right'}}  onClick={() => { resetDataStates(); fetchData(0); applyFilters(); }} >Apply Filters</Button>
                </div>
                
            </div>
        </div>
        
        <Box sx={{ height: 'auto', width: '100%' }}>
            <DataGrid rows={allData.map((row, i) => ({...row,srNo: i + 1 ,id: row.row_temp_id || `${pageIndex}-${i}`}))}
                columns={[
                    { field: 'srNo',            headerName: 'Sr. No.',      flex: 0.5, sortable: false, filterable: false,},
                    { field: 'customer_name',   headerName: 'Name',         flex: 1, },
                    { field: 'customer_mobile', headerName: 'Mobile',       flex: 1, },
                    { field: 'customer_email',  headerName: 'Email',        flex: 1, },
                    { field: 'order_amount',    headerName: 'Order Amount', flex: 1, },
                    { field: 'coupon_code',     headerName: 'Draw Code',    flex: 1, },
                    { field: 'date_added',      headerName: 'Date Added',   flex: 1, },                    
                  ]}

                pageSize={Number(filters.pageSize)}
                onPageSizeChange={(newSize) => setFilters((prev) => ({ ...prev, pageSize: String(newSize) })) }
                pageSizeOptions={[10, 15, 20, 25, 40, 50, 80, 100]}
                pagination
                
                disableSelectionOnClick
                initialState={{pagination: {paginationModel: {pageSize: Number(filters.pageSize),page: 0,},},}}
                slots={{toolbar: CustomToolbar, footer: () => ( <CustomFooterWithLoadMore onLoadMore={() => fetchData(pageIndex + 1)} hasMoreData={hasMoreData} loading={loading} /> ), }}
                slotProps={{toolbar: {showQuickFilter: true,quickFilterProps: { debounceMs: 300 },},}}
                sx={{ '& .MuiDataGrid-cell': {fontSize: '13px', }, 
                    '& .MuiDataGrid-columnHeaderTitle': {fontSize: '15px',fontWeight: 'bold', whiteSpace: 'normal !important', 
                            lineHeight: '1.5', textAlign: 'center',},
                        "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {outline: "none"} }}
                rowHeight={38} headerHeight={45}
                
            />
        </Box>
    
    </Container>
    </div>
  );
};

export default ApiList;